import { askApi, clientUrl, clientInviteUrl } from '../endpoints';

export function getClients() {
    return new Promise((resolve) => {
        askApi.get(clientUrl).then((response) => {
            if (response.status === 200) {
                resolve(response.data);
            }
        });
    });
}

export function addClient(payload) {
    return new Promise((resolve) => {
        askApi.post(clientUrl, payload).then((response) => {
            if (response.status === 200) {
                resolve(response.data);
            }
        });
    });
}

export function updateClient(payload) {
    return new Promise((resolve) => {
        askApi.patch(clientUrl, payload).then((response) => {
            if (response.status === 200) {
                resolve(response.data);
            }
        });
    });
}

export function removeClient(payload) {
    return new Promise((resolve) => {
        askApi.delete(clientUrl, { data: payload }).then((response) => {
            if (response.status === 200) {
                resolve(response.data);
            }
        });
    });
}

export function inviteClient(payload) {
    return new Promise((resolve) => {
        askApi.patch(clientInviteUrl, payload).then((response) => {
            if (response.status === 200) {
                resolve(response.data);
            }
        });
    });
}
